import { AxiosRequestConfig } from "axios"
import { AnyKindOfDictionary } from "lodash"

import { privateFetch, publicFetch } from "../libs/axios"
import {
  CreateProductParticipantCategoryRequestTypes,
  CreateProductPricingRequestType,
  GetAllProductParticipantCategoryTypes,
  GetAllProductPricingTypes,
  PricingRule,
} from "../types/ProductPricingTypes"

export const getProductParticipantCategories = async (config: AxiosRequestConfig = {}) => {
  const response = await privateFetch().get<GetAllProductParticipantCategoryTypes>(
    "/api/v1/unit",
    config
  )
  return response.data.data
}

export const getProductParticipantCategoryById = async (
  id: string,
  config: AxiosRequestConfig = {}
) => await privateFetch().get(`/api/v1/unit/${id}`, config)

export const createProductParticipantCategory = async (
  body: CreateProductParticipantCategoryRequestTypes
) => await privateFetch().post("/api/v1/unit", body)

export const updateProductParticipantCategory = async (
  id: string,
  body: CreateProductParticipantCategoryRequestTypes
) => await privateFetch().put(`/api/v1/unit/${id}`, body)

export const deleteProductParticipantCategory = async (id: string) =>
  await privateFetch().delete(`/api/v1/unit/${id}`)

export const getProductPricingByProdId = async (
  id: string,
  config: AxiosRequestConfig = {},
  isIntegratedPage?: boolean | undefined,
  slot_id?: string
) => {
  if (isIntegratedPage) {
    return await publicFetch().get<GetAllProductPricingTypes>(
      `/api/v1/public/product/${id}/price?slot_id=${slot_id}`,
      config
    )
  }
  return await privateFetch().get<GetAllProductPricingTypes>(
    `/api/v1/product/${id}/price?slot_id=${slot_id}`,
    config
  )
}

export const createProductPricing = async (id: string, body: CreateProductPricingRequestType) =>
  await privateFetch().post(`/api/v1/product/${id}/price`, body)

export const updateProductPricing = async (
  id: string,
  pricingId: string,
  body: CreateProductPricingRequestType
) => await privateFetch().put(`/api/v1/product/${id}/price/${pricingId}`, body)

export const getGiftCardPricingById = async (productId: string, isIntegratedPage: boolean) => {
  if (isIntegratedPage) {
    return await publicFetch().get<AnyKindOfDictionary>(`/api/v1/public/product/${productId}/price`)
  }
  return await privateFetch().get<any>(`/api/v1/product/${productId}/price`)
}

export const getMerchandisePricingByQuantities = async (
  productId: string,
  body: any,
  isIntegratedPage: boolean
) => {
  if (isIntegratedPage) {
    return await publicFetch().post<any>(
      `/api/v1/public/product/${productId}/availability/live-quantity`,
      body
    )
  }
  return await privateFetch().post<any>(
    `/api/v1/product/${productId}/availability/live-quantity`,
    body
  )
}
